module.exports = __webpack_public_path__ + "img/290b386.svg";